import { useState } from "react";
import FieldValidationError from "./FieldValidationError";

const InputPassword = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    const { error, ...inputProps } = props;

    return (
        <>
            <div className="input-group input-password">
                <input
                    type={showPassword ? "text" : "password"}
                    className="form-control input-default"
                    {...inputProps}
                    style={{ borderRight: 'none', ...inputProps.style }}
                />
                <span
                    className="input-group-text bg-white"
                    style={{ cursor: 'pointer', borderLeft: 'none', borderColor: '#d9e4ec' }}
                    onClick={() => setShowPassword(!showPassword)}
                >
                    <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-muted`}></i>
                </span>
            </div>
            <FieldValidationError error={error} />
        </>
    );
}

export default InputPassword;
